<div class="card-wrapper">
  <odx-card
    [variant]="'launch-tile'"
    odxLayout="flex"
    class="search-item"
    [class.bom-only]="!canAddToFloorplan || isShownOnProductList"
    (click)="onCardClick()"
  >
    <odx-avatar [ngClass]="'avatar'">
      <app-product-image [imageUrl]="imageUrl" [iconSize]="'56px'"></app-product-image>
    </odx-avatar>
    <div class="title" [odxTooltip]="displayName" odxTooltipSize="medium">{{ displayName }}</div>
    <odx-launch-card-subtitle>
      @if (!canAddToFloorplan && !isShownOnProductList) {
        <odx-chip class="list-chip" variant="highlight">
          <odx-icon name="group" alignleft color="blue"></odx-icon>
          <span i18n="@@productSearch.bomOnlyNote"> Nur Produktliste</span>
        </odx-chip>
      }
      <p class="odx-text--small" [odxTooltip]="displayId" odxTooltipSize="medium">{{ displayId }}</p>
    </odx-launch-card-subtitle>
  </odx-card>
  @if ((canAddToFloorplan && !isShownOnProductList) || isGroup) {
    <button class="menu-trigger" [odxMenu]="searchItemMenu" odxMenuPosition="bottom-end" (click)="$event.stopPropagation()">
      <odx-icon name="more" aria-hidden="true"></odx-icon>
    </button>
  }
</div>

<ng-template #searchItemMenu>
  <odx-menu>
    @if (isGroup) {
      <button odxButton odxMenuItem (click)="onShowGroupDetailsClick()">
        <odx-icon name="document" alignleft></odx-icon>
        <span i18n="@@monitoring.productSearch.showGroup">Gruppe anzeigen</span>
      </button>
    }
    @if (showAddToBomMenuItem && !isShownOnProductList) {
      <button odxButton odxMenuItem (click)="onAddToBomClick()">
        <odx-icon name="plus" alignleft></odx-icon>
        <span i18n="@@floorplan.menu.addToProductList">Zur Produktliste hinzufügen</span>
      </button>
    }
  </odx-menu>
</ng-template>
